import { useLocation } from 'react-router-dom';
import React from 'react';
import Button from '@material-ui/core/Button';
import GridContainer from '../../../@jumbo/components/GridContainer';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import Chip from '@material-ui/core/Chip';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CmtList from '../../../@coremat/CmtList';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import parse from 'html-react-parser';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import MuiAlert from '@material-ui/lab/Alert';
import { IntlProvider, useIntl } from 'react-intl';
import { injectIntl } from 'react-intl';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import axios from 'axios';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import Checkbox from '@material-ui/core/Checkbox';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import { LinearProgress } from '@material-ui/core';
import { myFormatDate2, myFormatPrice, getMyDate2, getMyDate3 } from '../../../@jumbo/utils/commonHelper';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import ResDetais from '../timeline/ResDetails';
import Snackbar from '@material-ui/core/Snackbar';
import { CallMade, CallReceived } from '@material-ui/icons';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#0063B1',
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 12,
  },
}))(TableCell);

function getBase64(file) {
  return new Promise(resolve => {
    let fileInfo;
    let baseURL = '';
    // Make new FileReader
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);

    // on reader load somthing...
    reader.onload = () => {
      // Make a fileInfo Object
      console.log('Called', reader);
      baseURL = reader.result;
      console.log(baseURL);
      resolve(baseURL);
      return baseURL;
    };
    console.log(fileInfo);
  });
}

const StyledTableRow = withStyles(theme => ({
  root: {},
}))(TableRow);

function getColor(x) {
  if (x == 0) return '#9DC63A';
  if (x == 1) return '#F1C01C';
  if (x == 2) return '#C63A3A';
  if (x == 3) return '#8E8CD8';
  if (x == 4) return '#c58cd8';
}

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

const useStyles = theme => ({
  card: {
    overflow: 'unset',
    marginTop: theme.typography.pxToRem(16),
  },
  cardContent: {
    position: 'relative',
    paddingBottom: 0,
  },
  card2: {
    overflow: 'unset',
    marginBottom: 0,
  },
  cardContent2: {
    position: 'relative',
    paddingBottom: 0,
    textAlign: 'center',
  },
  cardRoot: {
    position: 'relative',
  },
  root: {
    flexGrow: 1,
  },
  hotelSelect: {
    width: '100%',
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: '100px',
  },

  cardContentInner2: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',
  },

  scrollbarRoot: {
    height: '100%',
    marginRight: -24,
    paddingRight: 24,
    marginLeft: -24,
    paddingLeft: 24,
    marginTop: -5,
    paddingTop: 5,
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Messages extends React.Component {
  constructor(props) {
    super(props);
    var myhotelid = 0;
    var date2 = new Date();
    var date1 = new Date();
    date1.setDate(date2.getDate() - 30);
    this.state = {
      page: 0,
      rowsPerPage: 10,
      date1: date1,
      showFail: false,
      showSuccess: false,
      running2: false,
      doneStatus: 0,
      mode: this.props.bookingId != null ? 'view' : '',
      hotelId: myhotelid,
      selected: [],
      content: '',
      date2: date2,
      folderStatus: 0,
      viewInvoiceVisible: false,
      setStatus: 0,
      userActivities: [],
      conversations: [],
    };
    this.updateActivities = this.updateActivities.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.eventClick = this.eventClick.bind(this);
    this.handleClose2 = this.handleClose2.bind(this);
    this.handleCapture = this.handleCapture.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.doRefresh = this.doRefresh.bind(this);
    this.check = this.check.bind(this);
  }
  handleCapture({ target }) {
    this.setState({ filex: target.files[0] });
  }
  check(id, status) {
    this.setState(prevState => {
      const sel = [...this.state.selected];

      if (status && sel.indexOf(id) == -1) sel.push(id);
      if (!status && sel.indexOf(id) != -1) sel.splice(sel.indexOf(id), 1);
      return { selected: sel };
    });
  }

  componentDidMount() {
    const { currentPage, setCurrentPage } = this.context;
    const { intl } = this.props;
    setCurrentPage(intl.formatMessage({ id: 'pages.bookings' }));
    const { currentApplication, setCurrentApplication } = this.context;
    setCurrentApplication(0);
    console.log('tu');
    console.log(this.props.bookingId);
    if (this.props.bookingId == null) this.updateActivities();
    else this.eventClick('open', '', 5, this.props.bookingId);
  }

  handleClose2() {
    this.setState({ showFail: false, showSuccess: false });
    //  setOpen(false);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log('tu2');
    console.log(this.props.bookingId);
    if (prevProps.bookingId != this.props.bookingId && this.props.bookingId != '') {
      this.eventClick('open', '', 5, this.props.bookingId);
    }
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
    this.setState({ page: 0 });
  };

  doRefresh() {
    this.updateActivities();
  }

  handleChange(name, value) {
    if (value == null) return;
    if (name == 'file') {
      console.log(value);
      let reader = new FileReader();

      // Convert the file to base64 text

      reader.onload = function() {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');
        this.setState({ fileb64: b64, filesize: value.size, filename: value.name, filetype: value.type });
      }.bind(this);
      reader.readAsDataURL(value);

      return;
    }
    this.setState({ [name]: value }, () => {
      //   this.updateRooms();
    });
  }

  handleCustomChange(event, owner) {
    this.setState({ [owner]: event.target.value }, () => {
      //            this.updateRooms();
    });
  }

  handleChangePage(event, newPage) {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
    this.setState({ page: 0 });
  };

  checkDates() {
    if (this.state.date2 == null || Number(this.state.date2) <= Number(this.state.date1)) {
      var newdate = new Date(this.state.date1);
      newdate.setDate(newdate.getDate() + 1);
      this.setState({ date2: newdate });
    }
  }

  updateActivities() {
    if (this.state.date1 == null || this.state.date2 == null) return;
    var mydate1 = getMyDate(this.state.date1);
    var mydate2 = getMyDate(this.state.date2);
    const token = localStorage.getItem('token');
    var senddata = {};
    senddata = {
      Action: 'getConversations',
      token: token,
      Version: 1,
      Data: {
        hotelId: this.state.hotelId,
        fromDate: mydate1,
        toDate: mydate2,
        doneStatus: this.state.doneStatus,
        folderStatus: this.state.folderStatus,
        searchGuestName: this.state.searchGuestName,
      },
    };
    this.setState({ running2: true, mode: '' });

    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
      const self = this;
      //   const intl = useIntl();
      const data = res.data.Data;
      const myactivities = [];
      if (data != null) {
        data.forEach(
          function(item, index) {
            var newitem = {};
            newitem.id = item['id'];
            newitem.cancel_id = item['cancel_id'];

            if (item['icon'] == '') {
              newitem.channel = (
                <Chip
                  label={item['source']}
                  style={{ borderRadius: 2, backgroundColor: item['color'], color: item['fontColor'] }}
                />
              );
            } else {
              newitem.channel = (
                <img src={'https://app.webbookingpro.com/images/channels/' + item['icon']} style={{ height: 32 }} />
              );
            }
            newitem.source = item['source'];

            newitem.createdDate = getMyDate3(item['created'], this.props.auth.authUser.language);
            newitem.mystatus = 0;
            var status = item['status'];
            var mystatus = '';
            newitem.status = [];
            if (item['isRead'] == 0) {
              mystatus = <IntlMessages id="messages.unRead" />;
              newitem.mystatus = 1;
              var sc = getColor(newitem.mystatus);

              newitem.status.push(
                <Chip
                  label={mystatus}
                  style={{ marginRight: '5px', color: '#ffffff', fontWeight: 'bold', borderRadius: 2, backgroundColor: sc }}
                />,
              );
            }
            if (item['outgoing'] == 1) {
              mystatus = <IntlMessages id="messages.replied" />;
              newitem.mystatus = 1;
              var sc = getColor(newitem.mystatus);

              newitem.status.push(
                <Chip
                  label={mystatus}
                  style={{ marginRight: '5px', color: '#ffffff', fontWeight: 'bold', borderRadius: 2, backgroundColor: sc }}
                />,
              );
            }
            if (item['doneStatus'] == 1) {
              mystatus = <IntlMessages id="messages.statusDone" />;
              newitem.mystatus = 0;
              var sc = getColor(newitem.mystatus);

              newitem.status.push(
                <Chip
                  label={mystatus}
                  style={{ marginRight: '5px', color: '#ffffff', fontWeight: 'bold', borderRadius: 2, backgroundColor: sc }}
                />,
              );
            }

            if (item['folderStatus'] == 1) {
              mystatus = <IntlMessages id="messages.archived" />;
              newitem.mystatus = 2;
              var sc = getColor(newitem.mystatus);

              newitem.status.push(
                <Chip
                  label={mystatus}
                  style={{ marginRight: '5px', color: '#ffffff', fontWeight: 'bold', borderRadius: 2, backgroundColor: sc }}
                />,
              );
            }

            newitem.guestName = item['name'];
            var myhotelname = '';
            myhotelname = self.props.auth.authUser.hotels.find(({ id }) => id === item['hotelId']).name;
            //myhotelname = item['hotel_id'];
            newitem.hotelName = myhotelname;
            newitem.conversationId = item['conversationId'];
            newitem.bookingId = item['bookingId'];
            newitem.channelId = item['channelId'];
            newitem.hotelId = item['hotelId'];
            myactivities.push(newitem);
          }.bind(this),
        );
        this.setState({
          content: '',
          userActivities: myactivities,
          conversationId: '',
          bookingId: '',
          ahotelId: '',
          resDetailsVisible: false,
          channelId: '',
          conversations: [],
          selected: [],
          running2: false,
        });
      }
    });
  }

  eventClick(args, args2, args3, args4, args5) {
    //    setOpenRes(true);
    if (args == 'list') {
      this.updateActivities();
    } else if (args == 'downloadAttachment') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'downloadAttachment',
        token: token,
        Version: 1,
        Data: {
          conversationId: args2,
          channelId: args3,
          attachmentId: args4,
        },
      };

      const config = { responseType: 'blob' };
      const filename = args5;
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata, config).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    } else if (args == 'openreservation') {
      this.setState({ resDetailsVisible: true });
    } else if (
      args == 'listarchive' ||
      args == 'listdone' ||
      args == 'listundone' ||
      args == 'listunarchive' ||
      args == 'listdelete'
    ) {
      const token = localStorage.getItem('token');
      var senddata = {};
      senddata = {
        Action: 'archiveConversation',
        token: token,
        Version: 1,
      };

      if (args == 'listdelete') senddata.Action = 'deleteConversation';
      if (args == 'listdone') senddata.Action = 'markDoneConversation';
      if (args == 'listunread') senddata.Action = 'markUnreadConversation';
      if (args == 'listundone') senddata.Action = 'markUnDoneConversation';
      if (args == 'listunarchive') senddata.Action = 'markUnArchiveConversation';

      if (this.state.mode == 'view') {
        senddata.Data = { conversationId: args2, channelId: args3 };
      } else senddata.Data = { selection: this.state.selected };

      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
        this.updateActivities();
      });
    } else if (args == 'sendMessage') {
      /*  if (this.state.filex != null) {
        let reader = new FileReader();

        // Convert the file to base64 text

        reader.onload = function() {
          var b64 = reader.result.replace(/^data:.+;base64,/, '');
          var senddata = {};
          var xx = '';
          console.log('xx' + this.state.filex);
          senddata = {
            Action: 'sendMessage',
            token: token,
            Version: 1,
            Data: {
              conversationId: args2,
              content: this.state.content,
              channelId: this.state.channelId,
              bookingId: this.state.bookingId,
              file: { base64: b64 },
            },
          };
          alert(JSON.stringify(senddata));
        };
        reader.readAsDataURL(this.state.filex);
        return;
      }*/

      const token = localStorage.getItem('token');
      var senddata = {};

      senddata = {
        Action: 'sendMessage',
        token: token,
        Version: 1,
        Data: {
          conversationId: args2,
          content: this.state.content,
          channelId: this.state.channelId,
          bookingId: this.state.bookingId,
        },
      };
      if (this.state.filename != null) {
        var filexi = {
          name: this.state.filename,
          size: this.state.filesize,

          filetype: this.state.filetype,
          b64: this.state.fileb64,
        };
        senddata.Data.filex = [];
        senddata.Data.filex.push(filexi);
      }

      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
        if (res.data.success == 1) this.setState({ showSuccess: true });
        else this.setState({ showFail: true });
        if (this.props.bookingId == null) this.updateActivities();
        else this.eventClick('open', '', this.state.channelId, this.state.bookingId);
      });
    } else if (args == 'open') {
      const token = localStorage.getItem('token');
      var senddata = {};
      senddata = {
        Action: 'getConversation',
        token: token,
        Version: 1,
        Data: {
          conversationId: args2,
          channelId: args3,
          bookingId: args4,
        },
      };

      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;

      this.setState({ running2: true });
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
        this.setState({
          mode: 'view',
          conversationId: args2,
          channelId: args3,
          bookingId: args4,
          ahotelId: args5,
          running2: false,
          conversations: res.data.Data,
        });
      });
    } else if (args == 'filter') {
      this.updateActivities();
    }
    //alert(this.state.selReservationId);
  }

  render() {
    /*
       <Box className={classes.cardContentInner}>
                <FormControl variant="filled" className={classes.formControl}>
                  <Button variant="contained" color="primary" onClick={() => this.eventClick('createInvoice')}>
                    <IntlMessages id="invoices.createInvoice" />
                  </Button>
                </FormControl>
              </Box>
     */
    const { classes } = this.props;
    var actionTitle = '';
    var hotels = this.props.auth.authUser.hotels;
    const myDate = new Date();
    var dateDisplay = myDate.toISOString().split('T')[0];
    const columns = [
      { id: 'channel', label: <IntlMessages id="bookings.channel" />, minWidth: 100 },
      {
        id: 'hotelName',
        label: <IntlMessages id="bookings.property" />,
        minWidth: 120,
        align: 'left',
      },
      { id: 'createdDate', label: <IntlMessages id="invoice.createdDate" />, minWidth: 120 },

      {
        id: 'guestName',
        label: <IntlMessages id="bookings.guestName" />,
        minWidth: 120,
        align: 'center',
      },

      {
        id: 'status',
        label: <IntlMessages id="invoices.searchStatus" />,
        minWidth: 170,
        align: 'left',
      },
    ];
    return (
      <PageContainer heading={actionTitle}>
        {this.state.mode == '' && (
          <>
            <Paper className={classes.root}>
              <Box className={classes.cardContentInner}>
                {this.state.running2 && <LinearProgress />}

                <FormControl variant="filled" className={classes.formControl}>
                  <TextField
                    id="hotelid"
                    name="hotelid"
                    label={<IntlMessages id="bookings.selectHotel" />}
                    margin="normal"
                    select
                    defaultValue=""
                    value={this.state.hotelId}
                    onChange={event => this.handleChange('hotelId', event.target.value)}>
                    <MenuItem value={0}>
                      <IntlMessages id="invoices.allProperties" />
                    </MenuItem>
                    {hotels.map((t, idx) => (
                      <MenuItem value={t.id}>{t.name}</MenuItem>
                    ))}
                  </TextField>
                </FormControl>

                <FormControl variant="filled" className={classes.formControl}>
                  <TextField
                    id="searchStatus"
                    name="doneStatus"
                    margin="normal"
                    label={<IntlMessages id="messages.doneStatus" />}
                    select
                    defaultValue=""
                    value={this.state.doneStatus}
                    onChange={event => this.handleChange('doneStatus', event.target.value)}>
                    <MenuItem key="0" value="0">
                      <IntlMessages id="messages.allNotMarkedAsDone" />
                    </MenuItem>
                    <MenuItem key="1" value="1">
                      <IntlMessages id="messages.allMarkedAsDone" />
                    </MenuItem>
                    <MenuItem key="2" value="2">
                      <IntlMessages id="invoice.allDoneStatuses" />
                    </MenuItem>
                  </TextField>
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <TextField
                    id="searchStatus"
                    name="folderStatus"
                    margin="normal"
                    label={<IntlMessages id="messages.folderStatus" />}
                    select
                    defaultValue=""
                    value={this.state.folderStatus}
                    onChange={event => this.handleChange('folderStatus', event.target.value)}>
                    <MenuItem key="0" value="0">
                      <IntlMessages id="messages.inbox" />
                    </MenuItem>
                    <MenuItem key="1" value="1">
                      <IntlMessages id="messages.archived" />
                    </MenuItem>
                    <MenuItem key="2" value="2">
                      <IntlMessages id="invoice.allFolders" />
                    </MenuItem>
                  </TextField>
                </FormControl>

                <FormControl variant="filled" className={classes.formControl}>
                  <TextField
                    required
                    id="searchGuestName"
                    name="searchGuestName"
                    label={<IntlMessages id="bookings.guestName" />}
                    margin="normal"
                    defaultValue=""
                    onChange={event => this.handleChange('searchGuestName', event.target.value)}
                  />
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <DatePicker
                    variant="inline"
                    format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                    margin="normal"
                    id="date1"
                    name="date1"
                    autoOk="true"
                    label={<IntlMessages id="bookings.fromDate" />}
                    value={this.state.date1}
                    onChange={date => {
                      this.setState({ date1: date }, () => {
                        this.checkDates();
                      });
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <DatePicker
                    variant="inline"
                    format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                    margin="normal"
                    id="date2"
                    name="date2"
                    autoOk="true"
                    label={<IntlMessages id="bookings.toDate" />}
                    value={this.state.date2}
                    onChange={date => {
                      this.setState({ date2: date });
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </FormControl>
              </Box>
              <Box className={classes.cardContentInner2}>
                <FormControl variant="filled" className={classes.formControl}>
                  <Button variant="contained" color="primary" onClick={() => this.eventClick('filter')}>
                    <IntlMessages id="bookings.filter" />
                  </Button>
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <Button variant="contained" color="primary" onClick={() => this.eventClick('listdone')}>
                    <IntlMessages id="messages.markAsDone" />
                  </Button>
                </FormControl>

                <FormControl variant="filled" className={classes.formControl}>
                  <Button variant="contained" color="primary" onClick={() => this.eventClick('listarchive')}>
                    <IntlMessages id="messages.archive" />
                  </Button>
                </FormControl>
                <FormControl variant="filled" className={classes.formControl}>
                  <Button variant="contained" color="primary" onClick={() => this.eventClick('listdelete')}>
                    <IntlMessages id="messages.delete" />
                  </Button>
                </FormControl>
              </Box>

              <PerfectScrollbar className={classes.scrollbarRoot}>
                <TableContainer className={classes.container}>
                  <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell key="select" align="left" style={{ minWidth: 30 }}></StyledTableCell>
                        {columns.map(column => (
                          <StyledTableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                            {column.label}
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    </TableHead>

                    <TableBody>
                      {this.state.userActivities
                        .slice(
                          this.state.page * this.state.rowsPerPage,
                          this.state.page * this.state.rowsPerPage + this.state.rowsPerPage,
                        )
                        .map(row => {
                          var rowColor = '',
                            rowColor2 = '#000000';
                          /*var x = 1;
                          if (row['status'] == 1) x = 0;
                          if (row['cancel_id'] != null) x = 2;*/
                          rowColor = getColor(row['mystatus']);
                          return (
                            <StyledTableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.id}
                              selected={this.state.selected.indexOf(row.id) != -1}
                              aria-checked={this.state.selected.indexOf(row.id) != -1}
                              id={row.id}
                              //style={{ backgroundColor: rowColor }}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={this.state.selected.indexOf(row.id) != -1}
                                  onChange={event => this.check(row.id, event.target.checked)}
                                />
                              </TableCell>
                              {columns.map(column => {
                                const value = row[column.id];
                                return (
                                  <StyledTableCell
                                    key={column.id}
                                    align={column.align}
                                    onClick={() =>
                                      this.eventClick('open', row.conversationId, row.channelId, row.bookingId, row.hotelId)
                                    }>
                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                  </StyledTableCell>
                                );
                              })}
                            </StyledTableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={this.state.userActivities.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </PerfectScrollbar>
            </Paper>
          </>
        )}
        {this.state.mode == 'view' && (
          <>
            {this.state.running2 && <LinearProgress />}
            {this.state.running2 == false && (
              <Paper className={classes.root}>
                <Box className={classes.cardContentInner2}>
                  {this.props.bookingId == null && (
                    <FormControl variant="filled" className={classes.formControl}>
                      <Button variant="contained" color="primary" onClick={() => this.eventClick('list')}>
                        <IntlMessages id="appModule.back" />
                      </Button>
                    </FormControl>
                  )}
                  {this.props.bookingId == null && (
                    <FormControl variant="filled" className={classes.formControl}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.eventClick('listunread', this.state.conversationId, this.state.channelId)}>
                        <IntlMessages id="messages.markAsUnread" />
                      </Button>
                    </FormControl>
                  )}
                  {this.state.conversations.length > 0 && this.state.conversations[0].doneStatus == 0 && (
                    <FormControl variant="filled" className={classes.formControl}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.eventClick('listdone', this.state.conversationId, this.state.channelId)}>
                        <IntlMessages id="messages.markAsDone" />
                      </Button>
                    </FormControl>
                  )}
                  {this.state.conversations.length > 0 && this.state.conversations[0].doneStatus == 1 && (
                    <FormControl variant="filled" className={classes.formControl}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.eventClick('listundone', this.state.conversationId, this.state.channelId)}>
                        <IntlMessages id="messages.markAsUnDone" />
                      </Button>
                    </FormControl>
                  )}
                  {this.state.conversations.length > 0 && this.state.conversations[0].folderStatus == 0 && (
                    <FormControl variant="filled" className={classes.formControl}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.eventClick('listarchive', this.state.conversationId, this.state.channelId)}>
                        <IntlMessages id="messages.archive" />
                      </Button>
                    </FormControl>
                  )}
                  {this.state.conversations.length > 0 && this.state.conversations[0].folderStatus == 1 && (
                    <FormControl variant="filled" className={classes.formControl}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.eventClick('listunarchive', this.state.conversationId, this.state.channelId)}>
                        <IntlMessages id="messages.unArchive" />
                      </Button>
                    </FormControl>
                  )}
                  {this.props.bookingId == null && (
                    <FormControl variant="filled" className={classes.formControl}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.eventClick('listdelete', this.state.conversationId, this.state.channelId)}>
                        <IntlMessages id="messages.delete" />
                      </Button>
                    </FormControl>
                  )}
                  {this.props.bookingId == null && (
                    <FormControl variant="filled" className={classes.formControl}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => this.eventClick('openreservation', this.state.bookingId)}>
                        <IntlMessages id="calendar.viewReservation" />
                      </Button>
                    </FormControl>
                  )}
                </Box>
              </Paper>
            )}
            {this.state.running2 == false && this.state.conversations.length == 0 && (
              <Alert severity="info">
                <IntlMessages id="noMessages" />
              </Alert>
            )}
            {this.state.conversations.map((item, index) => (
              <Paper className={classes.root}>
                <CmtCard className={classes.card}>
                  <CmtCardContent className={classes.cardContent}>
                    <Box className={classes.cardContentInner}>
                      {item.outgoing == 1 && <CallMade />}
                      {item.outgoing == 0 && <CallReceived />}
                      {getMyDate3(item['created'], this.props.auth.authUser.language)}
                      <br />
                      {item.content}

                      {item.attachments.length > 0 &&
                        item.attachments.map(aitem => (
                          <>
                            <br />
                            {aitem.name + ' '}
                            {aitem.size != '' && <>{aitem.size + ' '}</>}
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() =>
                                this.eventClick(
                                  'downloadAttachment',
                                  this.state.conversationId,
                                  this.state.channelId,
                                  aitem.id,
                                  aitem.name,
                                )
                              }>
                              <IntlMessages id="downloadAttachment" />
                            </Button>
                          </>
                        ))}
                    </Box>
                  </CmtCardContent>
                </CmtCard>
              </Paper>
            ))}
            <Paper className={classes.root}>
              <CmtCard className={classes.card}>
                <CmtCardContent className={classes.cardContent}>
                  <Box className={classes.cardContentInner}>
                    <form>
                      <TextField
                        label={<IntlMessages id="message" />}
                        id="content"
                        name="content"
                        margin="content"
                        rows={6}
                        variant="outlined"
                        fullWidth
                        multiline="true"
                        value={this.state.content}
                        onChange={event => this.handleChange('content', event.target.value)}
                      />

                      <TextField
                        type="file"
                        variant="outlined"
                        onChange={event => this.handleChange('file', event.target.files[0])}
                        fullWidth
                      />
                    </form>
                  </Box>
                  <FormControl variant="filled" className={classes.formControl}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => this.eventClick('sendMessage', this.state.conversationId)}>
                      <IntlMessages id="messages.sendMessage" />
                    </Button>
                  </FormControl>
                </CmtCardContent>
              </CmtCard>
            </Paper>
          </>
        )}
        <ResDetais
          resId={this.state.bookingId}
          resTitle={this.state.bookingId}
          open={this.state.resDetailsVisible}
          hotelId={this.state.ahotelId}
          //            doRefresh={this.doRefresh}
          setState={p => {
            this.setState(p);
          }}
        />
        <Snackbar open={this.state.showSuccess} autoHideDuration={500} onClose={this.handleClose2}>
          <Alert severity="success">
            <IntlMessages id="message.success" />
          </Alert>
        </Snackbar>
        <Snackbar open={this.state.showFail} autoHideDuration={500} onClose={this.handleClose2}>
          <Alert severity="error">
            <IntlMessages id="message.fail" />
          </Alert>
        </Snackbar>
      </PageContainer>
    );
  }
}

Messages.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};
Messages.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(Messages)));
